<template>
  <SpanText
    class="inline-flex items-center rounded-full font-medium"
    font="font-medium"
    :color="textColor"
    :size="textSize"
    :class="classes"
  >
    <slot />
  </SpanText>
</template>

<script setup>
import { computed } from 'vue'
import SpanText from '@/Common/Text/SpanText.vue'
import { bgColorClasses } from '../../util/colorMap'

const props = defineProps({
  color: {
    type: String,
    default: 'gray',
  },
  size: {
    type: String,
    default: 'sm',
  },
})

const textColor = computed(() => {
  return {
    gray: 'text-gray-800',
    red: 'text-red-800',
    yellow: 'text-yellow-800',
    green: 'text-green-800',
    blue: 'text-blue-800',
    indigo: 'text-indigo-800',
    purple: 'text-purple-800',
    pink: 'text-pink-800',
  }[props.color]
})

const backgroundColor = computed(() => {
  return {
    gray: bgColorClasses('bg-gray-100'),
    red: bgColorClasses('bg-red-100'),
    yellow: bgColorClasses('bg-yellow-100'),
    green: bgColorClasses('bg-green-100'),
    blue: bgColorClasses('bg-blue-100'),
    indigo: bgColorClasses('bg-indigo-100'),
    purple: bgColorClasses('bg-purple-100'),
    pink: bgColorClasses('bg-pink-100'),
  }[props.color]
})

const sizeClasses = computed(() => {
  return {
    sm: 'px-2.5 py-0.5',
    lg: 'px-3 py-0.5',
  }[props.size]
})

const classes = computed(() =>
  [backgroundColor.value, sizeClasses.value].join(' ')
)

const textSize = computed(() => {
  return {
    sm: 'text-xs',
    lg: 'text-sm',
  }[props.size]
})
</script>
